import { render, staticRenderFns } from "./FormEditArticle.vue?vue&type=template&id=16e0ac38&scoped=true"
import script from "./FormEditArticle.vue?vue&type=script&lang=js"
export * from "./FormEditArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0ac38",
  null
  
)

export default component.exports